import { render, staticRenderFns } from "./Programa-viewrest.vue?vue&type=template&id=b2ed5202&scoped=true"
import script from "./Programa-viewrest.vue?vue&type=script&lang=js"
export * from "./Programa-viewrest.vue?vue&type=script&lang=js"
import style0 from "./Programa-viewrest.vue?vue&type=style&index=0&id=b2ed5202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ed5202",
  null
  
)

export default component.exports